import { GpusList } from '@/react/docker/host/SetupView/GpusList';

import { SwitchField } from '@@/form-components/SwitchField';
import { TextTip } from '@@/Tip/TextTip';
import { FormSection } from '@@/form-components/FormSection';

import { DockerSetupFormData } from './types';

interface SectionProps {
  formData: DockerSetupFormData;
  onChange: <K extends keyof DockerSetupFormData>(
    key: K,
    value: DockerSetupFormData[K]
  ) => void;
}

export function OtherSection({ formData, onChange }: SectionProps) {
  return (
    <FormSection title="Other">
      <div className="form-group">
        <div className="col-sm-12">
          <TextTip color="blue">
            Showing GPU in the UI is currently only available with Docker
            Standalone and is limited to NVIDIA graphics cards.
          </TextTip>
        </div>
      </div>

      <div className="form-group">
        <div className="col-sm-12">
          <SwitchField
            checked={formData.enableGpuManagement}
            onChange={(value) => onChange('enableGpuManagement', value)}
            label="Show GPU in the UI"
            tooltip="This allows managing of GPUs for container/stack hardware acceleration via the Portainer UI. GPU support is currently limited to NVIDIA graphics cards only."
            labelClass="col-sm-7 col-lg-4"
            data-cy="enable-gpu-management-switch"
          />
        </div>

        {formData.enableGpuManagement && (
          <div className="col-sm-12">
            <div className="pl-4">
              <GpusList
                value={formData.gpus}
                onChange={(value) => onChange('gpus', value)}
              />
            </div>
          </div>
        )}
      </div>

      <div className="form-group">
        <div className="col-sm-12">
          <SwitchField
            checked={formData.enableImageNotification}
            onChange={(value) => onChange('enableImageNotification', value)}
            label="Show image up to date indicators for Stacks, Services and Containers"
            labelClass="col-sm-7 col-lg-4"
            data-cy="enable-image-notification-switch"
          />
        </div>
      </div>
    </FormSection>
  );
}
